import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import utils from "ulysses/widgets/search/utils";
import markup from "ulysses/widgets/search/search.html";
import widget_markup from "ulysses/widgets/search/search_widget.html";
import result_markup from "ulysses/widgets/search/search_result.html";
import facets_markup from "ulysses/widgets/search/faceting/facets_list.html";
import "ulysses/widgets/search/search";

$(document).ready(function() {
    $(markup).appendTo($("body"));
    $(result_markup + widget_markup + facets_markup).appendTo($("body"));
});


function edit_search_settings(current_data) {
    var res = Promise.Deferred();
    var cdata = ko.toJS(current_data);
    var pres =uly.page.page_resource();
    var has_screen_configuration = false;
    if (pres && typeof pres.search_meta != "undefined") {
        cdata.use_screen_configuration = cdata.use_screen_configuration || false;
        has_screen_configuration = cdata.has_screen_configuration = true;
    }
    var dialog = uly.dialogs.execute($("#search-settings-editor-tmpl").html(), {
        "title":_("search_widget_title_edit_search_configuration", "Edit Search Configuration")
    }, cdata).done(function([result]) {
        var result_data =  {
            "contextual":ko.unwrap(result.contextual) || false,
            "navigable":ko.unwrap(result.navigable) || false,
            "filter":ko.unwrap(result.filter) || null,
            "parameter_names": ko.unwrap(result.parameter_names) || null,
            "parametrised_filters": ko.unwrap(result.parametrised_filters) || null,
            "panel_markup": ko.unwrap(result.panel_markup) || null,
            "display_mode": ko.unwrap(result.display_mode) || 'list',
            "search_sort": ko.unwrap(result.search_sort) || "-significant_date",
            "custom_facets": ko.unwrap(result.custom_facets) || [],
            "custom_controls": ko.unwrap(result.custom_controls) || []
        };
        if (has_screen_configuration) {
            result_data.use_screen_configuration = ko.unwrap(result.use_screen_configuration) || false;
        }
        res.resolve(result_data);
    }).fail(res.reject);
    return res.promise();
}

function ensureSettingsComplete(origSettings) {
    return utils.ensure_settings_complete(origSettings);
}

ko.bindingHandlers.searchwidget = {
    "inititial_value":function(){
        var data = {
            "filter": null,
            "contextual": true,
            "navigable": true,
            "panel_markup":  null,
            "parameter_names":  null,
            "parametrised_filters": null,
            "display_mode": 'list',
            "search_sort": "-significant_date",
            "use_screen_configuration": null,
            "custom_facets": [],
            "custom_controls": []
        };

        var initDef = Promise.Deferred();
        edit_search_settings(data).done(function(result) {
            data.filter = ko.unwrap(result.filter);
            data.contextual = ko.unwrap(result.contextual);
            data.navigable = ko.unwrap(result.navigable);

            data.parameter_names = ko.unwrap(result.parameter_names);
            data.parametrised_filters = ko.unwrap(result.parametrised_filters);
            data.panel_markup = ko.unwrap(result.panel_markup);
            data.display_mode = ko.unwrap(result.display_mode);
            data.search_sort = ko.unwrap(result.search_sort);
            data.custom_facets = ko.unwrap(result.custom_facets);
            data.custom_controls = ko.unwrap(result.custom_controls);
            data.use_screen_configuration = ko.unwrap(result.use_screen_configuration);

            initDef.resolve(data);
        }).fail(initDef.reject);
        return initDef;
    },
    "init":function(elt, va, bindings, model, context) {
        var widget_model = ko.unwrap(va());
        widget_model.icon("fa fa-search");
        widget_model.error = ko.observable(null);
        widget_model.subtitle = ko.observable(null);
        
        //widget_model.search_model = ko.observable(null);

        var $search_elt = $(elt).children(".search");
        var settings_menu = widget_model.settings_menu;
        // Ensure settings are complete
        var res = ensureSettingsComplete(ko.unwrap(widget_model.settings));
        var settings = res[0], modified=res[1];
        if (modified) {
            settings = $.extend({}, settings);
            widget_model.settings(settings);
        }

        settings_menu.push({
            "caption":_("search_widget_caption_modify", "Modify"),
            "icon":"fa-edit",
            "action":function(e){
                var settings = ko.unwrap(widget_model.settings);
                var component_type = settings.compact ? "sidebar" : "page";
                edit_search_settings(settings).done(function(result) {
                    settings = $.extend({}, settings, {
                        filter: result.filter,
                        contextual: result.contextual,
                        navigable:  result.navigable,
                        parameter_names: result.parameter_names,
                        parametrised_filters: result.parametrised_filters,
                        panel_markup: result.panel_markup,
                        display_mode: result.display_mode,
                        search_sort: "-significant_date",
                        custom_facest: result.custom_facets,
                        custom_controls: result.custom_controls,
                        use_screen_configuration: result.use_screen_configuration
                    });
                    //widget_model.settings(settings);
                    widget_model.settings({
                        filter: result.filter,
                        contextual: result.contextual,
                        navigable:  result.navigable,
                        parameter_names: result.parameter_names,
                        parametrised_filters: result.parametrised_filters,
                        panel_markup: result.panel_markup,
                        display_mode: result.display_mode,
                        search_sort: result.search_sort,
                        custom_facets: result.custom_facets,
                        custom_controls: result.custom_controls,
                        use_screen_configuration: result.use_screen_configuration
                    });
                    uly.publish(component_type + ".savesettings");
                });
            },
            "colour":"primary",
            "permission": "editpage"
        });


        var childContext = context.extend({"widget_model":widget_model});
        ko.applyBindingsToDescendants(childContext, elt);

        uly.subscribe("widget.remove", function(topic, widget) {
            if (widget != elt)
                return false;
            ko.removeNode(elt);
        }, elt);

        return { controlsDescendantBindings: true };
    },
    "update":function(elt, va, allbindings, model, context) {
        var widget_model = ko.unwrap(va());
        var search_settings = ko.unwrap(widget_model.settings);
        if (!widget_model.title())
            widget_model.title(_("search_widget_default_title", "Search"));
        var updating = $(elt).children(".search").data("search-updating");
        if (updating)
            return;

        uly.publish("widget.loading", elt);
    }
};


uly.widgets.register({
    "type":"search",
    "caption":_("search_widget_caption_search", "Search"),
    "description":_("search_widget_description_a_search_widget", "A search widget"),
    "icon":"fa-search",
    "init":ko.bindingHandlers.searchwidget.inititial_value,
    "colour":"aqua",
    "actions":[]
});
